


































import { computed, nextTick, ref, watch } from '@vue/composition-api'
import { defineClassComponent, useMessenger } from '@/hooks'
import { makeConditionalArray } from 'vtils'

export default defineClassComponent<{
  preOrderData: any
  value: boolean
}>(
  {
    props: ['preOrderData', 'value'],
  },
  ({ props, ctx }) =>
    class {
      constructor() {
        if (this.payChannels.value.length === 1) {
          this.handlePayClick()
        }

        watch(
          () => props.value,
          () => {
            if (props.value) {
              this.payChannelIndex.value = props.preOrderData.supportPayType
                ? 0
                : this.payChannelIndex.value
            }
          },
        )
      }

      visible = useMessenger(
        () => props.value,
        visible => ctx.$emit('input', visible),
      )

      payChannels = computed(() =>
        makeConditionalArray<{
          channel: 'dcb' | 'qsxfj' | 'yzf'
          name: string
          icon: string
          payType?: number
        }>([
          // 支持消费金支付时隐藏收银台支付
          !props.preOrderData.supportPayType && {
            channel: 'dcb',
            name: '收银台（微信、云闪付）',
            icon: require('./images/收银台.png'),
          },
          props.preOrderData.supportPayType && {
            channel: 'qsxfj',
            name: '消费金支付',
            icon: require('./images/消费金支付.png'),
          },
          props.preOrderData.supportYiPay && {
            channel: 'yzf',
            name: '翼支付',
            icon: require('./images/翼支付.png'),
            payType: 15,
          },
        ]),
      )

      payChannelIndex = ref(0)

      handleCancelClick = () => {
        this.visible.value = false
        nextTick(() => {
          ctx.$emit('cancel')
        })
      }

      handlePayClick = () => {
        this.visible.value = false
        nextTick(() => {
          ctx.$emit(
            'confirm',
            this.payChannels.value[this.payChannelIndex.value],
          )
        })
      }
    },
)
